import { DogSummary, FILTER_TYPE } from 'types/Dog';
import { FilterSet } from 'types/Option';

const customKeys = {
    [FILTER_TYPE.INSTITUTION]: 'institutionRefId',
    [FILTER_TYPE.SHELTER]: 'shelterRefId'
}

export const filterList = (dogList: DogSummary[], selectedFilters: FilterSet) => {
    return (dogList || []).filter(dog => { // get only dogs matching condition
        return Object.values(selectedFilters)
            .every(optGroup => !optGroup.length || optGroup.some(opt => { // every option group either has no options selected or some match
                const key = customKeys[opt.type] || opt.type;
                return dog[key] == opt.value
            }))
    })
}
